// test961
(961 && 0);
